import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=19ad6e2c&scoped=true"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad6e2c",
  null
  
)

export default component.exports